import Header from '../Components/Header/Header.js'
import Questions from '../Components/Questions/Questions.js'
import Footer from '../Components/Footer/Footer.js'

export default function Ajuda() {
  return (
    <div className="App">
      <Header />
       <div
        style={{
          background: 'linear-gradient(to left, #0E0326, #2D1A57)',
          justifyContent: 'center',
          alignItems: 'center',
          paddingTop: '3em',
          paddingBottom: '5em'
        }}
      ></div> 
      <Questions />
      <Footer />
    </div>
  )
}
